import { ServiceData } from '@/types';

import articles from './FITNESS_ARTICLES_FR.json';
import exercises from './FITNESS_EXERCISES_FR.json';
import recipes from './FITNESS_RECIPES_FR.json';

export const FITNESS_DATA_FR: ServiceData = {
  articles,
  exercises,
  recipes,
};
